module.exports = __webpack_public_path__ + "img/eyebrow_male_straight_average.76acf233.png";